module.exports = __webpack_public_path__ + "img/student_10.615a47fd.png";